import React from 'react';

const isWindows10 = () => {
  const ua = navigator.userAgent;
  if (!ua.includes('Windows NT 10.0')) return false;
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    ctx.font = '12px sans-serif';
    ctx.fillText('🪙', 0, 12);
    const data = ctx.getImageData(0, 0, 14, 14).data;
    const hasColor = Array.from(data).some((v, i) => i % 4 !== 3 && v > 10);
    return !hasColor;
  } catch { return true; }
};

const CoinIcon = ({ size = '1em', style = {} }) => {
  if (typeof window !== 'undefined' && isWindows10()) {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24"
        style={{ display: 'inline-block', verticalAlign: 'middle', ...style }}>
        <defs>
          <radialGradient id="cgold" cx="35%" cy="35%">
            <stop offset="0%" stopColor="#ffe566" />
            <stop offset="60%" stopColor="#d4a017" />
            <stop offset="100%" stopColor="#a07820" />
          </radialGradient>
        </defs>
        <circle cx="12" cy="12" r="11" fill="url(#cgold)" stroke="#a07820" strokeWidth="1.5" />
        <text x="12" y="16" textAnchor="middle" fontSize="11"
          fontWeight="bold" fill="#7a5c00">₵</text>
      </svg>
    );
  }
  return <span style={{ display: 'inline-block', verticalAlign: 'middle', ...style }}>🪙</span>;
};

export default CoinIcon;
